/**
 * Koji DE — dodanie produktu z upsella w cart drawerze (koji-cart-upsell.liquid).
 *
 * Klik w „Hinzufügen" dodaje 1 szt. wybranego wariantu jako osobną pozycję BEZ właściwości
 * `_bundle` (żeby nie wpadła w próg rabatu pakietowego), przez event Horizona
 * `CartLinesUpdateEvent` odświeża cart drawer (pozycja się pojawia, przelicza się
 * darmowa dostawa, upsell sam się chowa). Delegacja na document → przeżywa re-render sekcji.
 *
 * Fallback: przy błędzie przekierowuje na /cart.
 */

import { CartLinesUpdateEvent } from '@shopify/events';

function routeBase() {
  const r =
    window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  return r.replace(/\/$/, '');
}

async function addUpsell(btn) {
  const id = Number(btn.getAttribute('data-variant-id'));
  if (!id) return;

  const base = routeBase();
  const items = [{ id, quantity: 1 }];

  btn.setAttribute('disabled', 'disabled');
  btn.classList.add('is-loading');

  // sekcje do re-renderu (wiersze koszyka / drawer) — jak natywny add
  const sectionIds = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
  });
  const sections = Array.from(sectionIds).join(',');

  const deferred = CartLinesUpdateEvent.createPromise();

  try {
    // informujemy motyw, że trwa dodawanie (drawer zostaje otwarty i się odświeża).
    // UWAGA: NIE przekazywać `bubbles`/`composed` w options — konstruktor robi
    // Object.assign(this, options), a bubbles to na Event getter tylko do odczytu → TypeError.
    // Event jest bubbles/composed już z definicji CartLinesUpdateEvent (jak w bundle-add).
    btn.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((it) => ({
          merchandiseId: 'gid://shopify/ProductVariant/' + it.id,
          quantity: it.quantity,
        })),
        promise: deferred.promise,
      })
    );

    const res = await fetch(base + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname,
      }),
    });
    if (!res.ok) throw new Error('add failed');
    const data = await res.json();

    let cart = null;
    try {
      const cres = await fetch(base + '/cart.js', {
        headers: { Accept: 'application/json' },
      });
      cart = CartLinesUpdateEvent.createCartFromAjaxResponse(await cres.json());
    } catch (e) {
      /* noop */
    }

    deferred.resolve({
      cart,
      detail: {
        sections: data.sections,
        items: data.items,
        source: 'koji-upsell',
        itemCount: 1,
      },
    });
  } catch (e) {
    if (typeof deferred.reject === 'function') deferred.reject(e);
    window.location.href = base + '/cart';
    return;
  } finally {
    btn.removeAttribute('disabled');
    btn.classList.remove('is-loading');
  }
}

// Karuzela upselli — CROSSFADE: przełączamy klasę .is-active na slajdach (opacity),
// slajdy ułożone w grid-stacku (CSS). Bez translateX/scroll (scrollLeft zablokowany w <dialog>).
function navCarousel(navBtn) {
  const carousel = navBtn.closest('[data-koji-upsell-carousel]');
  if (!carousel) return;
  const slides = carousel.querySelectorAll('.koji-upsell__slide');
  const count = slides.length;
  if (count < 2) return;
  const dir = navBtn.getAttribute('data-koji-upsell-nav') === 'next' ? 1 : -1;
  let idx = parseInt(carousel.getAttribute('data-index') || '0', 10) + dir;
  if (idx < 0) idx = count - 1;
  if (idx > count - 1) idx = 0;
  carousel.setAttribute('data-index', String(idx));
  slides.forEach((slide, i) => {
    const active = i === idx;
    slide.classList.toggle('is-active', active);
    slide.setAttribute('aria-hidden', active ? 'false' : 'true');
  });
}

// Delegacja na document — działa też po re-renderze przez Section Rendering API.
if (!window.__kojiUpsellInit) {
  window.__kojiUpsellInit = true;
  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const addBtn = e.target.closest('[data-koji-upsell-add]');
    if (addBtn) {
      addUpsell(addBtn);
      return;
    }
    const navBtn = e.target.closest('[data-koji-upsell-nav]');
    if (navBtn) navCarousel(navBtn);
  });
}
